<template>
  <div>
    <div
      class="intent-item pa-0 mb-3"
      @click="item.expand = !item.expand"
      :style="`border: 1px solid ${$vuetify.theme.primary};`"
    >
      <div v-if="!isEdit" class="pa-0">
        <div class="px-3 pt-2 pb-1">
          <v-layout row wrap>
            <v-flex xs8>
              <p>
                <i
                  aria-hidden="true"
                  class="v-icon material-icons theme--light"
                  :style="`color: ${active?'rgb(160, 232, 61)': '#d6d6d6'}; caret-color: rgb(160, 232, 61);`"
                >fiber_manual_record</i>
                {{item.name}}
              </p>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <v-btn
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="active"
                @click.stop="editauction"
              >
                <i class="fas fa-pencil-alt"></i>
              </v-btn>
            </v-flex>
          </v-layout>

          <div class="text-xs-right">
            <span
              :class="{'fas fa-chevron-down': !item.expand,'fas fa-chevron-up': item.expand }"
              style="font-size: 1.5em; margin-right: 5px; cursor: pointer; color: rgb(255, 112, 107);"
            ></span>
          </div>
        </div>
        <div v-if="item.expand">
          <v-divider></v-divider>
          <div class="pa-4">
            <v-layout>
              <v-flex xs6>
                <v-layout row wrap class="pr-3">
                  <v-flex xs6>
                    <p>ต่ำสุด</p>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right pr-3">
                    <div class="primary-color">{{item.minprice | numberFormat}}</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="pr-3">
                  <v-flex xs6>
                    <p>สูงสุด</p>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right pr-3">
                    <div class="primary-color">{{item.maxprice| numberFormat}}</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="pr-3">
                  <v-flex xs6>
                    <p>เวลาสิ้นสุดการประมูล</p>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right pr-3">
                    <div class="primary-color">{{item.endtime| dateFormat('DD/MM/YYYY HH:mm')}}</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <p>ข้อความสรุปการประมูล</p>
                    </div>
                    <div class="message auctionmessage">
                      <specialtext :text="item.summarytext"></specialtext>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="pt-3">
                    <div>
                      <p>ข้อความแจ้งเตือน (ราคาไม่อยู่ในช่วงที่กำหนด)</p>
                    </div>
                    <div class="message auctionmessage">
                      <specialtext :text="item.warningmessage"></specialtext>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="pt-3">
                    <div>
                      <p>ข้อความแจ้งเตือน (ไม่ตรงตามรูปแบบ)</p>
                    </div>
                    <div class="message auctionmessage">
                      <specialtext :text="item.msginvalidformat"></specialtext>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
      <div v-else>
        <AstonAuctionManager :data="item" @onUpdate="onUpdate" @close="isEdit=false"></AstonAuctionManager>
      </div>
    </div>
  </div>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
import AstonAuctionManager from './AstonAuctionManager.vue'

export default {
  props: ['item', 'active'],
  components: {
    specialtext,
    AstonAuctionManager,
  },
  data() {
    return {
      isEdit: false,
    }
  },
  methods: {
    editauction() {
      this.isEdit = true
    },
    onUpdate(data) {
      this.isEdit = false
      this.$emit('updateData', data)
    },
  },
}
</script>

<style lang="scss">
.auctionmessage {
  position: relative;
  border-radius: 12px;
  overflow-wrap: break-word;
  min-height: 22px;
  min-width: 14px;
  overflow: hidden;
  margin-bottom: 5px;
  white-space: initial;
  float: left;
  padding: 5px 8px 6px;
  background-color: rgb(241, 240, 240);
}
</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AstonAuctionItem.vue